import { render, staticRenderFns } from "./NeuroscienceEvaluationQuestionnaire.vue?vue&type=template&id=93bb1068&"
import script from "./NeuroscienceEvaluationQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./NeuroscienceEvaluationQuestionnaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports